import { render, staticRenderFns } from "./BemTerceiroList.vue?vue&type=template&id=2365ef48"
import script from "./BemTerceiroList.vue?vue&type=script&lang=js"
export * from "./BemTerceiroList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports